"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotDownloadCloud = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotDownloadCloud = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M32.562 36.385c2.014-2.938 1.484-7.56.954-13.088-.53-5.53-1.06-11.966-4.4-14.263-3.366-2.298-9.515-.455-14.497 2.484-4.983 2.964-8.773 6.998-8.614 10.71.159 3.713 4.24 7.052 7.448 10.284 3.207 3.232 5.565 6.303 9.01 7.211 3.473.882 8.058-.373 10.099-3.338Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M13.332 28.333 20 34.999m0 0 6.667-6.666m-6.667 6.666V20m14.8 10.15a8.333 8.333 0 0 0-4.8-15.15h-2.1a13.333 13.333 0 1 0-22.9 12.15"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotDownloadCloud = SpotDownloadCloud;
SpotDownloadCloud.displayName = "SpotDownloadCloud";